'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;
/* injects from baggage-loader */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCanvas = require('react-canvas');

var _measureText = require('../utils/measureText');

var _measureText2 = _interopRequireDefault(_measureText);

var _getProjectBase64SrcImage = require('./getProjectBase64SrcImage');

var _getProjectBase64SrcImage2 = _interopRequireDefault(_getProjectBase64SrcImage);

var _getProjectDimentions2 = require('components/Projects/utils/getProjectDimentions');

var _getProjectDimentions3 = _interopRequireDefault(_getProjectDimentions2);

var _logo = require('./logo');

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BACKGROUND_COLOR = '#F2F2F2';
var SURFACE_WIDTH = 600;
var SURFACE_HEIGHT = 400;
var LOGO_SRC = _logo2.default;
var PROJECT_ZOOM_FACTOR = 1.7;

// const PROJECT_IMAGE_TOP_FACTOR = 0.6;

var getFontStyles = function getFontStyles(_ref) {
  var weight = _ref.weight;
  var size = _ref.size;
  var _ref$lineHeight = _ref.lineHeight;
  var lineHeight = _ref$lineHeight === undefined ? size * 1.3 : _ref$lineHeight;
  return {
    fontSize: size,
    lineHeight: lineHeight,
    fontFace: (0, _reactCanvas.FontFace)('Roboto, sans-serif', null, { weight: weight })
  };
};

var ProjectShareRenderer = (_temp = _class = function (_Component) {
  _inherits(ProjectShareRenderer, _Component);

  function ProjectShareRenderer() {
    _classCallCheck(this, ProjectShareRenderer);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectShareRenderer).apply(this, arguments));
  }

  _createClass(ProjectShareRenderer, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var authorName = _props.authorName;
      var projectTitle = _props.projectTitle;
      var project = _props.project;
      var width = _props.width;
      var height = _props.height;


      var projectBackgroundSrc = (0, _getProjectBase64SrcImage2.default)(project);

      return _react2.default.createElement(
        _reactCanvas.Surface,
        {
          top: 0, left: 0,
          width: width, height: height,
          style: { width: width, height: height }
        },
        _react2.default.createElement(
          _reactCanvas.Group,
          { style: this.getGroupStyle() },
          _react2.default.createElement(_reactCanvas.Image, {
            src: projectBackgroundSrc,
            style: this.getBackgroundProjectImageStyle()
          }),
          _react2.default.createElement(
            _reactCanvas.Text,
            { style: this.getProjectTitleStyle() },
            this.getProjectTitleText(projectTitle)
          ),
          _react2.default.createElement(
            _reactCanvas.Text,
            { style: this.getProjectAuthorStyle() },
            'by ' + authorName
          ),
          _react2.default.createElement(
            _reactCanvas.Text,
            { style: this.getLogoCaptionStyle() },
            'Meta Projects'
          ),
          _react2.default.createElement(_reactCanvas.Image, { style: this.getLogoImageStyle(), src: LOGO_SRC })
        )
      );
    }
  }, {
    key: 'getGroupStyle',
    value: function getGroupStyle() {
      var _props2 = this.props;
      var width = _props2.width;
      var height = _props2.height;


      return {
        top: 0,
        left: 0,
        width: width,
        height: height,
        backgroundColor: BACKGROUND_COLOR
      };
    }
  }, {
    key: 'getBackgroundProjectImageStyle',
    value: function getBackgroundProjectImageStyle() {
      var _props3 = this.props;
      var surfaceWidth = _props3.width;
      var surfaceHeight = _props3.height;
      var project = _props3.project;

      var _getProjectDimentions = (0, _getProjectDimentions3.default)(project);

      var width = _getProjectDimentions.width;
      var height = _getProjectDimentions.height;


      var projectRenderWidth = width * PROJECT_ZOOM_FACTOR;
      var projectRenderHeight = height * PROJECT_ZOOM_FACTOR;

      return {
        top: surfaceHeight * 0.65,
        left: surfaceWidth / 2 - projectRenderWidth / 2,
        width: projectRenderWidth,
        height: projectRenderHeight
      };
    }
  }, {
    key: 'getProjectTitleStyle',
    value: function getProjectTitleStyle() {
      var _props4 = this.props;
      var width = _props4.width;
      var height = _props4.height;


      var fontSize = 72;

      return _extends({
        top: height / 2 - 128,
        left: width * 0.1,
        width: width * 0.8,
        maxWidth: width * 0.8,

        height: fontSize

      }, getFontStyles({
        weight: 400, size: fontSize, lineHeight: 80
      }), {

        textAlign: 'center',
        color: '#000'
      });
    }
  }, {
    key: 'getProjectTitleText',
    value: function getProjectTitleText(text) {
      var width = this.props.width;


      var fontSize = 72;

      var metrics = (0, _measureText2.default)({
        text: text, maxWidth: width * 0.8,
        fontFamily: 'Roboto, sans-serif',
        fontSize: fontSize,
        lineHeight: fontSize
      });

      var lines = metrics.lines;

      var linesCount = lines.length;
      var firstLineText = lines[0].text;

      if (linesCount === 1) {
        return firstLineText;
      }

      return firstLineText + '…';
    }
  }, {
    key: 'getProjectAuthorStyle',
    value: function getProjectAuthorStyle() {
      var _props5 = this.props;
      var width = _props5.width;
      var height = _props5.height;


      return _extends({
        top: height / 2 - 8,
        left: 0,
        width: width,
        height: 32

      }, getFontStyles({ weight: 500, size: 32 }), {

        textAlign: 'center',
        lineHeight: 32,
        color: '#333'
      });
    }
  }, {
    key: 'getLogoImageStyle',
    value: function getLogoImageStyle() {
      return {
        top: 28,
        left: 34,
        width: 60,
        height: 60
      };
    }
  }, {
    key: 'getLogoCaptionStyle',
    value: function getLogoCaptionStyle() {
      var width = this.props.width;


      return _extends({
        top: 42,
        left: 110,
        width: width,
        height: 32

      }, getFontStyles({ weight: 500, size: 24 }), {
        textAlign: 'left',
        color: '#000'
      });
    }
  }]);

  return ProjectShareRenderer;
}(_react.Component), _class.propTypes = {
  project: _react.PropTypes.object.isRequired,
  authorName: _react.PropTypes.string.isRequired,
  projectTitle: _react.PropTypes.string.isRequired,
  width: _react.PropTypes.number.isRequired,
  height: _react.PropTypes.number.isRequired
}, _class.defaultProps = {
  width: SURFACE_WIDTH,
  height: SURFACE_HEIGHT
}, _temp);
exports.default = ProjectShareRenderer;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectShareRenderer/ProjectShareRenderer.js
// module id = 218
// module chunks = 1